<script setup>
</script>

<template>
  <footer class="border-t" style="background-color: var(--color-krate-dark-900); color: var(--color-krate-dark-300);">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
      <div>
        <h3 class="font-semibold text-white flex items-center gap-2">
          <img src="/img/logo.svg" alt="" width="24" height="24" />
          <span>krate</span>
        </h3>
      </div>
      <div>
        <h3 class="font-semibold text-white mb-3">Product</h3>
        <ul class="space-y-2">
          <li><router-link to="/pricing" class="hover:text-white">Pricing</router-link></li>
          <li><router-link to="/roadmap" class="hover:text-white">Roadmap</router-link></li>
          <li><a href="https://github.com/krate-dot-sh/krate-docs" class="hover:text-white">Docs</a></li>
          <li><router-link to="/status" class="hover:text-white">Status</router-link></li>
        </ul>
      </div>
      <div>
        <h3 class="font-semibold text-white mb-3">Company</h3>
        <ul class="space-y-2">
          <li><a href="https://github.com/krate-dot-sh" class="hover:text-white">GitHub</a></li>
          <li><router-link to="/sign-in" class="hover:text-white">Sign in</router-link></li>
        </ul>
      </div>
      <div>
        <h3 class="font-semibold text-white mb-3">Legal</h3>
        <ul class="space-y-2">
          <li><router-link to="/privacy" class="hover:text-white">Privacy</router-link></li>
          <li><router-link to="/terms" class="hover:text-white">Terms</router-link></li>
          <li><router-link to="/trust" class="hover:text-white">Trust Center</router-link></li>
        </ul>
      </div>
    </div>
    <div class="border-t" style="border-color: var(--color-krate-dark-700);">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs">
        <p>© 2026 Kannister. krate is open source.</p>
      </div>
    </div>
  </footer>
</template>
